import PageHero from '../components/ui/PageHero';
import LegalContent from '../components/ui/LegalContent';
import { company } from '../data/company';

const sections = [
  {
    heading: '1. Acceptance of Terms',
    paragraphs: [
      'By accessing and using Tecnvirons’ field-service and maintenance operations platform, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.',
    ],
  },
  {
    heading: '2. Description of Service',
    paragraphs: ['Tecnvirons provides a field-service and maintenance operations platform including but not limited to:'],
    list: [
      'Appointment scheduling and booking, including AI voice and WhatsApp-assisted booking',
      'Workforce management, task assignment, and field job tracking via the Tecnvi Ongo companion app',
      'Customer management for both individual (B2C) and business (B2B) accounts',
      'Product, service, and inventory catalog management',
      'Order management, dispatch, and invoicing',
      'Subscription and AMC (annual maintenance contract) order automation and recurring billing',
      'Customer self-service via the Tecnvi Connect companion channel',
      'Consulting and implementation services, technical support and maintenance',
    ],
  },
  {
    heading: '3. User Responsibilities',
    paragraphs: ['As a user of our services, you agree to:'],
    list: [
      'Provide accurate and complete information when required',
      'Maintain the security of your account credentials',
      'Use our services in compliance with applicable laws and regulations',
      'Not attempt to gain unauthorized access to our systems',
      'Not use our services for any illegal or unauthorized purpose',
      'Respect intellectual property rights',
    ],
  },
  {
    heading: '4. Intellectual Property Rights',
    paragraphs: [
      'All content, features, and functionality of our services, including but not limited to text, graphics, logos, icons, images, data compilations, and software, are the exclusive property of Tecnvirons and are protected by copyright, trademark, and other intellectual property laws.',
    ],
  },
  {
    heading: '5. Service Availability',
    paragraphs: ['We strive to maintain high availability of our services, but we do not guarantee uninterrupted access. Our services may be temporarily unavailable due to:'],
    list: [
      'Scheduled maintenance',
      'Technical difficulties',
      'Circumstances beyond our control',
      'Security-related issues',
    ],
  },
  {
    heading: '6. Payment Terms',
    paragraphs: ['For paid plans:'],
    list: [
      'Payment is due according to the agreed billing cycle (monthly, quarterly, half-yearly or annually)',
      'All fees are non-refundable unless otherwise specified',
      'We reserve the right to suspend services for non-payment',
      'Prices may change with 30 days’ notice',
    ],
  },
  {
    heading: '7. Limitation of Liability',
    paragraphs: [
      'To the maximum extent permitted by law, Tecnvirons shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses.',
    ],
  },
  {
    heading: '8. Termination',
    paragraphs: [
      'We may terminate or suspend your access to our services immediately, without prior notice, for any reason, including but not limited to breach of these Terms. Upon termination, your right to use the services will cease immediately.',
    ],
  },
  {
    heading: '9. Governing Law',
    paragraphs: [
      'These Terms shall be interpreted and governed by the laws of India. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts in India.',
    ],
  },
  {
    heading: '10. Changes to Terms',
    paragraphs: [
      'We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms of Service on this page. Your continued use of the service after such modifications constitutes acceptance of the updated terms.',
    ],
  },
  {
    heading: '11. SMS & WhatsApp Services',
    paragraphs: [
      'Program/Brand: This SMS program is operated by Tecnvirons (brand name "Tecnvirons"). Tecnvirons may send alerts, notifications, appointment/booking confirmations, and marketing promotions by SMS or WhatsApp to the mobile number you provide.',
      'How You Opt In: You opt in to receive SMS messages when you submit your phone number through one of our web forms (such as the "Book a Demo" or contact form on this site) and check the SMS consent checkbox, or when you provide your mobile number to our team by phone or WhatsApp and affirmatively agree to receive messages. Each opt-in method requires your clear, affirmative action — no phone number is enrolled without it. Consent to receive SMS messages is not a condition of purchasing any goods or services.',
      'Message Frequency: Message frequency varies and may be recurring (for example, appointment reminders, service updates, or renewal notices) depending on your interactions with us. Message and data rates may apply.',
      'Opt-Out Instructions: Reply STOP at any time to any message to opt out of further messages. After you text STOP, we will send a one-time confirmation that you have been unsubscribed, and you will receive no further messages from this program unless you opt in again.',
      'Help: Reply HELP for help, or contact us at ' + company.email + ' or ' + company.offices[0].phone + '. In response to a HELP request, we will reply with the Tecnvirons brand name and this support contact information.',
      'Carrier Disclaimer: Supported carriers include AT&T, T-Mobile, Verizon, Sprint, and other participating carriers. Carriers are not liable for delayed or undelivered messages. Tecnvirons is not liable for delayed or undelivered messages.',
      'Privacy Policy & Data Usage: We respect your privacy. We will only use the phone number and information you provide to transmit your messages and administer this program. Text messaging originator opt-in data and consent will not be shared with any third parties for marketing purposes. See our Privacy Policy for more details.',
    ],
  },
  {
    heading: '12. Contact Information',
    paragraphs: [
      'If you have any questions about these Terms of Service, please contact us:',
      `Email: ${company.email}`,
      ...company.offices.map((o) => `${o.label} — ${o.legalName}, ${o.address} — ${o.phone}`),
    ],
  },
];

export default function TermsOfService() {
  return (
    <div>
      <PageHero
        eyebrow="Terms of Service"
        title="The fine print, plainly stated."
        body="Please read these terms carefully before using our field-service and maintenance operations platform."
      />
      <LegalContent
        intro="Welcome to Tecnvirons. These Terms of Service govern your use of our field-service and maintenance operations platform, including the Tecnvi Ongo and Tecnvi Connect companion apps. By accessing or using our services, you agree to be bound by these terms."
        sections={sections}
      />
    </div>
  );
}
